var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEditActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.6%",
    y: "-3.6%",
    width: "107.1%",
    height: "107.1%",
    filterUnits: "objectBoundingBox",
    id: "icon-edit-active_svg__b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-25%",
    y: "-5.9%",
    width: "200%",
    height: "123.5%",
    filterUnits: "objectBoundingBox",
    id: "icon-edit-active_svg__c"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "icon-edit-active_svg__a",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6a2 2 0 0 1 2 2v10h-4V8a2 2 0 0 1 2-2Zm0 17-2-4h4l-2 4Z",
    id: "icon-edit-active_svg__d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#B9B9B9",
    xlinkHref: "#icon-edit-active_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#icon-edit-active_svg__b)",
    xlinkHref: "#icon-edit-active_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30 14 14.5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#icon-edit-active_svg__c)",
    xlinkHref: "#icon-edit-active_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#icon-edit-active_svg__d"
  })))));
}

export default SvgIconEditActive;